import React from "react";
import "../style/MetamaskFail.css";

function MetamaskFail() {
  return (
    <div className="metamaskfail">
      <div className="centerDivMetamask">
        <h1>Metamask Not Found !</h1>
        <p>
          Download Metamask extension or any other ethereum wallet to use this
          decentralised website
        </p>
      </div>
    </div>
  );
}

export default MetamaskFail;
